<template>
    <div class="home-page">
		<Header></Header>
		<div class="content">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('TC')}}</span>
			</div>
			<div class="information">
				<div class="faq-content" v-if="list!=''">
					<div class="">
						<p v-html="list"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:''

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome()
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {
			  type:'2'
			}
			that.$api.post('/api/help/help',data,r =>{
				that.$parent.returnCode(r,function(){
					that.list = r.data.content
					that.$parent.loadModal(false);
				});

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/termsAndCondition.vue